// extracted by mini-css-extract-plugin
export default {"bullet-list":"bullet-list-0b0e","flexWrap":"flexWrap-7e30","wrap":"wrap-c2d6","bullet":"bullet-a215","small":"small-a8cc"};